import { color } from '@upstox/upstox-ui';

export const container: CSSFunction = () => ({
  padding: '16px',
  width: '100%',
});

export const closeIcon: CSSFunction = ({ theme }) => ({
  cursor: 'pointer',
  height: '24px',
  width: '24px',
  color: color(theme, 'icon1'),
});

export const title: CSSFunction = ({ theme }) => ({
  fontWeight: 700,
  fontSize: '16px',
  color: color(theme, 'text.1'),
});
